import { render, staticRenderFns } from "./RecentEventsForm.vue?vue&type=template&id=44a59c27&"
import script from "./RecentEventsForm.vue?vue&type=script&lang=js&"
export * from "./RecentEventsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports